







































import {Vue, Component, Prop} from 'vue-property-decorator';
import HoldQiDetails from "@/domainObjects/hold/HoldQiDetails";
import WipQiDetails from "../../domainObjects/wip/WipQiDetails";

@Component({
})

export default class QiDetailForm extends Vue {
    @Prop({required: true}) detail!: HoldQiDetails | WipQiDetails;
    @Prop({required: false}) disabled!: boolean;

}

